import { useEffect, useRef, useState } from "react";
import { getElements2, exportParamsFile_fg, uploadFile_fg, download_ } from '../../services/services';
import EditableTable from "../MyUI/EditableTable/EditableTable";
import { validateRows } from "../MyUI/EntityTableTemplate/validateEntity";
import FileInput from "../MyUI/FileInput/FileInput";

export default function ParametersFileGenerator() {
  const formRef = useRef();
  const [combboxElements, setCombboxElements] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [error, setError] = useState("");

  const [params, setParams] = useState([{
    element_id: "",
    system_subsystem_element_description: "",
    HFI_or_LFI: "HFI",
    author: "",
    verified_by: "",
  }]);

  const [params2, setParams2] = useState([
    { second_id: 1, Phase: "", 'Likelihood_for_Triangle': "1", 'Severity_for_Triangle': "1", 'Likelihood_for_2L': "1", 'Severity_for_2L':"1" },
  ]);
  
  useEffect(() => {
    fetchElements2();
  }, []);

  const fetchElements2 = async () => {
      //setLoading(true);
      try {
        const res = await getElements2(
        {
        filters: [],
        pagen: 1,
        itemsPerPage: 1000,
        sortBy: '',
        sortDesc: false,
      });
      const list = res.data.params.map(p => ({
        label: `${p.element_name} ${p.pbscode}`,
        value: p.id
      }));
      
        setCombboxElements(list);
      } catch (err) {
        console.error(err);
        console.error('Error fetching elems:', error);
      } finally {
      //  setLoading(false);
      }
  };
  const HFI_LFI_OPTIONS = {
    HFI: "HFI",
    LFI: "LFI",
  };

  const Likelihood_OPTIONS = {
    1: "negligible",
    2: "minor",
    3: "moderate",
    4: "major",
    5: "catastrophic",
};
  const Severity_OPTIONS = {
    1: "very low",
    2: "Low",
    3: "Moderate (Medium)",
    4: "High",
    5: "very high",
};

// Load XLSX dynamically (like Vue mounted())
  useEffect(() => {
    if (!window.XLSX) {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.0/xlsx.full.min.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);


  const exportParamsFile = async () => {
    setIsExporting(true);
    setError("");

    const results1 = validateRows(params, defaultColumns1);
    const results2 = validateRows(params2, defaultColumns2);

    const allInvalidFields = [
      ...results1.invalidFields,
      ...results2.invalidFields,
    ];

    const allValid =
      results1.isValid &&
      results2.isValid;

    if (!allValid) {
      setError(
        "Invalid fields:\n" +
          allInvalidFields
            .map(f => `Row ${f.row + 1} - ${f.key}: ${f.message}`)
            .join("\n")
      );
      setIsExporting(false);
      return;
    }

    const selected = combboxElements.find(
      i => i.value === params[0].element_id
    );

    const parts = selected.label.split(" ");
    const pbsCode = parts[parts.length - 1];
    const [, second] = pbsCode.split(".");

    if (params[0].HFI_or_LFI === "LFI" && second === "1") {
      setError("LFI requires PBS second digit = 2");
      setIsExporting(false);
      return;
    }

    if (params[0].HFI_or_LFI === "HFI" && second === "2") {
      setError("HFI requires PBS second digit = 1");
      setIsExporting(false);
      return;
    }
    //console.log(params2);
    const payload = {
      data_infos0: {
        element_name: parts[0],
        pbscode: pbsCode,
        HFI_or_LFI: params[0].HFI_or_LFI,
      },
      data_infos: params,
      Risk_Parameters: params2
    };
    try{
    const workbook = window.XLSX.utils.book_new();

    // Sheet 1
    const ws1 = window.XLSX.utils.json_to_sheet(params);
   window.XLSX.utils.book_append_sheet(
      workbook,
      ws1,
      "General Informations"
    );

    // Sheet 2
    const exportParams2 = params2.map(row => ({
  ...row,
  "Criticality(Triangle)":
    Number(row.Likelihood_for_Triangle) *
    Number(row.Severity_for_Triangle),

  "Criticality(2L)":
    Number(row.Likelihood_for_2L) *
    Number(row.Severity_for_2L),
}));
const ws2 = window.XLSX.utils.json_to_sheet(exportParams2);
        
//const ws2 = window.XLSX.utils.json_to_sheet(params2);
    window.XLSX.utils.book_append_sheet(
      workbook,
      ws2,
      "Risk Parameters"
    );

    window.XLSX.writeFile(
      workbook,
      "RiskExport.xlsx"
    );

  }
    catch(err){

      console.error('Error Exporting:', err);
    }
    finally{
      setIsExporting(false);
    }
  };

  const uploadFile = (file) => {
  if (!file) return;

  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target.result);

      const workbook = window.XLSX.read(data, {
        type: "array",
      });

      // Read sheets
      const generalSheet = workbook.Sheets["General Informations"];
      const risksSheet = workbook.Sheets["Risk Parameters"];

      if (generalSheet) {
        const importedParams =
          window.XLSX.utils.sheet_to_json(generalSheet);

        setParams(importedParams);
      }

      if (risksSheet) {
        const importedRisks =
          window.XLSX.utils.sheet_to_json(risksSheet);

        setParams2(importedRisks);
      }

    } catch (err) {
      console.error("Import error:", err);
      setError("Invalid XLSX file");
    }
  };

  reader.readAsArrayBuffer(file);
};


  const requiredFields = ["Phase", "Category", "RiskTitle", "RiskImpact", "ImpactCategory", "Risk_Reporter_Source_of_Info", "Likelihood_for_Triangle", "Severity_for_Triangle", "Likelihood_for_2L", "Severity_for_2L"];
// Validation
  const missingRequiredFields2 = params2.flatMap((row, rowIndex) =>
    requiredFields
      .filter((key) => !row[key])
      .map((key) => `${key} (row ${rowIndex + 1})`)
  );
  
  const defaultColumns1 = [
    { key: 'element_id', label: 'element_id', type: 'Autocomplete', Autocomplete:combboxElements, placeholder:'Select PBS element', validation: 'required' },
    { key: 'system_subsystem_element_description', label: 'system_subsystem_element_description', type: 'input' },
    { key: 'HFI_or_LFI', label: 'HFI_or_LFI', type: 'select', SELECT_OPTIONS:HFI_LFI_OPTIONS, validation: 'required' },
    { key: 'author', label: 'author', type: 'input', validation: ['required'], placeholder:'author' },
    { key: 'verified_by', label: 'verified_by', type: 'input', placeholder:'verified_by', validation: 'required' },
  ];
  const defaultColumns2 = [
    { key: 'second_id', label: 'second_id', type: 'input', placeholder:'second id' },
    { key: 'Phase', label: 'Phase', type: 'input',  validation: 'required'},
    { key: 'Category', label: 'Category', type: 'input',  validation: 'required' },
    { key: 'RiskTitle', label: 'RiskTitle', type: 'input',  validation: 'required' },
    { key: 'Event_RiskDescription', label: 'Event_RiskDescription', type: 'input' },
    { key: 'RiskImpact', label: 'RiskImpact', type: 'input', validation: 'required' },
    { key: 'ImpactCategory', label: 'ImpactCategory', type: 'input', validation: 'required' },
    { key: 'Link_to_evidence_ReliableSources', label: 'Link_to_evidence_ReliableSources', type: 'input' },
    { key: 'Risk_Reporter_Source_of_Info', label: 'Risk_Reporter_Source_of_Info', type: 'input', validation: 'required' },
    { key: 'Comments', label: 'Comments', type: 'input' },
    { key: 'Likelihood_for_Triangle', label: 'Likelihood_for_Triangle', type: 'select', SELECT_OPTIONS:Likelihood_OPTIONS  },
    { key: 'Severity_for_Triangle', label: 'Severity_for_Triangle', type: 'select', SELECT_OPTIONS:Severity_OPTIONS  },
    { key: 'Criticality(Triangle)', label: 'Criticality(Triangle)', type: 'readonly' },
    { key: 'Likelihood_for_2L', label: 'Likelihood_for_2L', type: 'select', SELECT_OPTIONS:Likelihood_OPTIONS  },
    { key: 'Severity_for_2L', label: 'Severity_for_2L', type: 'select', SELECT_OPTIONS:Severity_OPTIONS  },
    { key: 'Criticality(2L)', label: 'Criticality(2L)', type: 'readonly2' },
    
    { key: 'Suggested_mitigation ', label: 'Suggested_mitigation', type: 'input'  },    
  ];
  return (
    <div>

        <h4 style={{textAlign:"center" ,color: "green", marginTop:"50px"}}>
                Risks template - July 2026
        </h4>
        {error && <span style={{ color: "red" }}>{error}</span>}
      <div className="local">
        <EditableTable
          title="General Informations"
          columns={defaultColumns1}  
          params={params}
          setParams={setParams}
          validateRows = {validateRows}
          addRows = {false}
        />
        <div className="validation-label">
          {missingRequiredFields2.length === 0
            ? "All fields OK ✅"
            : `Missing required fields ⚠️: ${missingRequiredFields2.join(", ")}`}
        </div>
      </div>
      <EditableTable
          title="Risk Parameters"
          columns={defaultColumns2}  
          params={params2}
          setParams={setParams2}
          validateRows = {validateRows}
          addRows = {true}
          defaultValues={{identity: "Functional", paramValue: '0'}}
        />

      <div style={{ textAlign: "center", marginTop: 20 }}>
              <button className = "default-btn" onClick={exportParamsFile} disabled={isExporting}>
                {isExporting ? "Exporting..." : "Download"}
              </button>
              {/* OR divider */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "16px 0",
                  fontSize: "12px"
                }}
              >
                <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
                <span style={{ margin: "0 10px" }}>or</span>
                <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
              </div>
                  
            </div>
      
            
            <div  style={{ display: "flex", justifyContent: "center", marginTop: 20, marginBottom:100 }}>
            <FileInput
              isBulk={false}
              labelSingle={`Upload .xlsx`}
              accept=".xlsx"
              onUploadComplete={(files) => {
    const file = files[0]?.file || files[0];

    if (file) {
      uploadFile(file);
    }
  }}
            />  
          </div>
    </div>
  );
}

